import React from 'react';

const Progress = () => {
    return (
        <div className='flex justify-center items-center'>
            <progress className="progress w-full"></progress>        
        </div>
    );
};

export default Progress;